import React from "react";

const ExtraItemsModalShimmer = () => {
  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 px-4">
      <div className="bg-white rounded-xl w-full max-w-sm p-4 space-y-4  ">
        {/* TITLE */}
        <div className="h-5 w-40 shimmer rounded mx-auto" />

        {/* ITEMS LIST */}
        <div className="max-h-64 overflow-y-auto space-y-1">
          {[1, 2].map((_, index) => (
            <div
              key={index}
              className={`flex justify-between items-center px-3 py-2 rounded ${
                index % 2 === 0 ? "bg-gray-100" : "bg-gray-50"
              }`}
            >
              <div className="flex items-center gap-2">
                {/* checkbox */}
                <div className="w-4 h-4 shimmer rounded-sm" />

                {/* item name */}
                <div className="h-4 w-28 shimmer rounded" />
              </div>

              {/* price */}
              <div className="h-4 w-12 shimmer rounded" />
            </div>
          ))}
        </div>

        {/* ADD NEW ITEM TEXT */}
        <div className="h-3 w-32 shimmer rounded mx-auto mt-2" />

        {/* INLINE FORM SHIMMER */}
        <div className="flex gap-2 items-center mt-2">
          <div className="flex-1 h-9 shimmer rounded-md" />
          <div className="w-16 h-9 shimmer rounded-md" />
          <div className="w-9 h-9 shimmer rounded-md" />
        </div>

        {/* BUTTONS */}
        <div className="flex gap-2 justify-between mt-2">
          <div className="w-full h-10 shimmer rounded-lg" />
          <div className="w-full h-10 shimmer rounded-lg" />
        </div>
      </div>
    </div>
  );
};

export default ExtraItemsModalShimmer;
